import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

/**
 * AnimationState
 * @description
 * This state governs the animation of the preview area across all of the creative units.
 * It is also used to help the timeline component know what to display.
 */

export interface AnimationState {
	isPlaying: boolean;
	isMuted: boolean;
	seek: number;
	timelineZoomLevel: number;
	timelinePrecisionLevel: number;
	activeAudioCreativeUnitId?: string;

	timelines: GSAPTimeline[];
}

export function createInitialState(): AnimationState {
	return {
		isPlaying: false,
		isMuted: true,
		seek: 0,
		timelineZoomLevel: 4,
		timelinePrecisionLevel: 4,
		timelines: []
	};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'global', resettable: true })
export class AdAnimationStore extends Store<AnimationState> {
	constructor() {
		super(createInitialState());
	}
}
